import React, { useEffect, useState } from 'react'
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';



const CompanyListModal = (props) => {

    const dispatch = useDispatch()
    const navigation = useNavigate()

    const [compantList, setCompanyList] = useState([])

    const [companySelectedItem, setCompanySelectedItem] = useState(0)

    useEffect(() => {
        if (props.isDisplayCompany === true) {
            setCompanyList(props.companyList)
            setCompanySelectedItem(props.selectedItem)
        }

    }, [props.companyList, props.isDisplayCompany, props.selectedItem])

    return (
        <>
            <div
                className="modal fade show"
                id="companylist"
                tabIndex={-1}
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
                style={{ display: props.isDisplayCompany === true ? 'block' : 'none' }}

            >
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">
                                Company List
                            </h5>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={() => {
                                    props.isDisplayCompanyClose(companySelectedItem)
                                }}
                            />
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                {
                                    compantList.map((item, index) => {
                                        return (
                                            <div className="col-12 col-md-6 mt-1 mb-2 mt-md-0 px-1">
                                                <div className={`card cursor-pointer ${companySelectedItem === item.id ? 'bg-primary' : ''}`}
                                                    onClick={() => {
                                                        setCompanySelectedItem(item.id)
                                                    }}>
                                                    <div className="card-body py-1">{item.name}</div>
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                        {/* <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                data-bs-dismiss="modal"
                                onClick={() => {
                                    props.isDisplayCompanyClose(companySelectedItem)
                                }}
                            >
                                Close
                            </button>
                        </div> */}
                    </div>
                </div>
            </div>
        </>
    )

}

export default CompanyListModal;